module.exports = __webpack_public_path__ + "static/media/img_step_1.781cef46.jpg";